import React from 'react';

import { BrancheDto } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { BrancheFormField, BrancheFormValue } from '../type';
import { buildDefaultUpdateFormValues, buildDto } from '../utils';

import ModalEdition from './ModalEdition';

interface ModalUpdateProps {
  branche: BrancheDto;
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
}

export default function ModalUpdate({
  branche,
  close,
  visible,
  refreshDashboard,
}: ModalUpdateProps): React.ReactElement {
  const initials: BrancheFormValue = buildDefaultUpdateFormValues(branche);
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: BrancheFormValue) =>
      AdminFonctionnelControllerApi.updateBrancheUsingPUT(
        branche.idCorrelation,
        buildDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (field: BrancheFormField, values: BrancheFormValue) =>
      AdminFonctionnelControllerApi.validateUpdateBrancheFieldUsingPOST(
        field,
        branche.idCorrelation,
        buildDto(values),
      ),
    response => response.brancheViolationsDto ?? [],
  );

  return (
    <ModalEdition
      close={close}
      visible={visible}
      title="Mise à jour de la branche"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
